import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./sidenav";
import TopNav from "./topnav";
import "./layout.css";

const SIDEBAR_PREF_PREFIX = "sidebarOpenPreference_v1";

function getSidebarPreferenceKey() {
    const tenantId = sessionStorage.getItem("tenantId") || "global";
    const userId = sessionStorage.getItem("userId") || "";
    const email = (sessionStorage.getItem("email") || "").toLowerCase();
    const role = sessionStorage.getItem("role") || "user";
    const identity = userId || email || role;
    return `${SIDEBAR_PREF_PREFIX}:${tenantId}:${identity}`;
}

function readDesktopSidebarPreference() {
    const value = localStorage.getItem(getSidebarPreferenceKey());
    if (value === "0") return false;
    if (value === "1") return true;
    return true;
}

const Layout = ({ children, noSidebar = false }) => {
    const navigate = useNavigate();
    const sidebarPreferenceKey = getSidebarPreferenceKey();

    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        if (typeof window === "undefined") return true;
        if (window.innerWidth < 1024) return false;
        return readDesktopSidebarPreference();
    });

    const persistSidebarPreference = (nextOpen) => {
        if (typeof window === "undefined") return;
        if (window.innerWidth < 1024) return;
        localStorage.setItem(sidebarPreferenceKey, nextOpen ? "1" : "0");
    };

    const handleSidebarToggle = (nextOpen) => {
        setIsSidebarOpen(!!nextOpen);
        persistSidebarPreference(!!nextOpen);
    };

    // Ctrl+V → navigate to Visualizer
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === "v" && e.target.tagName !== "INPUT" && e.target.tagName !== "TEXTAREA" && !e.target.isContentEditable) {
                e.preventDefault();
                navigate("/visualizer");
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [navigate]);

    // Handle responsive auto-close
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1024) {
                setIsSidebarOpen(false);
            } else {
                setIsSidebarOpen(readDesktopSidebarPreference());
            }
        };

        if (!noSidebar) {
            handleResize(); // Set initial
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }
    }, [noSidebar, sidebarPreferenceKey]);

    if (noSidebar) {
        return (
            <div className="app-layout no-sidebar">
                <div className="main-wrapper" style={{ marginLeft: 0, width: '100%' }}>
                    <main className="content-container" style={{ maxWidth: '100%', padding: 0 }}>
                        {children}
                    </main>
                </div>
            </div>
        );
    }

    return (
        <div className={`app-layout ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
            {isSidebarOpen && window.innerWidth < 1024 && (
                <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />
            )}
            <Sidebar onToggle={handleSidebarToggle} isOpen={isSidebarOpen} />
            <TopNav sidebarOpen={isSidebarOpen} />
            <div className="main-wrapper">
                <main className="content-container">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;
